import React from "react";
import ProductFirstApp from "./ProductFirstApp";
import {
  Stethoscope, Leaf, Pill, Activity, Flower2, Smile, Microscope, PlusSquare, Salad, Brain,
} from "lucide-react";

const CHIPS = [
  { id: "allopathy",     label: "Allopathy",      query: "allopathy",     icon: Stethoscope, color: "#7f1d1d", bg: "#fecaca" },
  { id: "ayurveda",      label: "Ayurveda",       query: "ayurveda",      icon: Leaf,        color: "#365314", bg: "#d9f99d" },
  { id: "homeopathy",    label: "Homeopathy",     query: "homeopathy",    icon: Pill,        color: "#164e63", bg: "#a5f3fc" },
  { id: "physio",        label: "Physiotherapy",  query: "physio",        icon: Activity,    color: "#7c2d12", bg: "#fed7aa" },
  { id: "yoga",          label: "Yoga Therapy",   query: "yoga",          icon: Flower2,     color: "#4c1d95", bg: "#ddd6fe" },
  { id: "dental",        label: "Dentistry",      query: "dent",          icon: Smile,       color: "#0c4a6e", bg: "#bae6fd" },
  { id: "pathology",     label: "Pathology Labs", query: "pathology",     icon: Microscope,  color: "#4c1d95", bg: "#e9d5ff" },
  { id: "pharmacy",      label: "Pharmacy",       query: "pharmacy",      icon: PlusSquare,  color: "#065f46", bg: "#a7f3d0" },
  { id: "nutrition",     label: "Nutrition",      query: "nutrition",     icon: Salad,       color: "#365314", bg: "#d9f99d" },
  { id: "mental-health", label: "Mental Health",  query: "counsel",       icon: Brain,       color: "#6b21a8", bg: "#e9d5ff" },
];

export default function Niramaya() {
  return (
    <ProductFirstApp
      appId="niramaya"
      theme={{ primary: "#0d9488", accent: "#14b8a6" }}
      hero={{
        background: "linear-gradient(135deg,#134e4a 0%, #0d9488 45%, #5eead4 100%)",
        overlay: "linear-gradient(135deg, rgba(4,25,25,0.42), rgba(4,25,25,0.06))",
        badge: "Niramaya · Care from your community — every stream of medicine",
        searchPlaceholder: "Search: ayurvedic doctor, physio, dental clinic, pathology…",
      }}
      chips={CHIPS}
    />
  );
}
